module.exports = __webpack_public_path__ + "static/img/home-item5.227d77e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-item5.png
// module id = KSkm
// module chunks = 21